import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import get from 'lodash/get';
import truncate from 'lodash/truncate';
import { withFormik } from 'formik';
import Yup from 'yup';
import FormField from 'cirrus/FormField';

import { entities } from 'pages/store/schema';
import { getValues, getProcessing, getErrors } from 'pages/store/selectors';
import { getData } from 'pages/store/actions/data';
import { actionTypes } from 'pages/store/actions/defaults';

import { Button } from '@lightspeed/flame/Button';
import Group from '@lightspeed/cirrus-group';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '@lightspeed/cirrus-modal';
import Select from '@lightspeed/cirrus-select';
import Text from '@lightspeed/cirrus-text';

class ShopModal extends Component {
  componentDidMount() {
    const { accountId } = this.props;

    this.props.getShopsData(`/staff/accounts/${accountId}/shops`);
  }

  render() {
    const {
      shopId,
      shops,
      values,
      setFieldValue,
      errors,
      handleSubmit,
      isSubmitting,
      onClose,
    } = this.props;

    return (
      <Modal className="cirrus" isOpen onRequestClose={() => onClose()}>
        <ModalHeader onCloseClicked={() => onClose()}>Synchronize from Retail Shop</ModalHeader>
        <ModalBody>
          <Text body color="gray">
            <strong>WARNING</strong>: This operation cannot be undone.
          </Text>
          <Text body>
            This operation will resync all product data and may take hours to complete.
          </Text>

          <div className="cr-pv-4">
            <Text body>Changing the Synchronize from Retail Shop will:</Text>
            <ul className="cr-mv-0">
              <li>
                <Text body color="gray">
                  synchronize available Quantity of products from the new Shop;
                </Text>
              </li>
              <li>
                <Text body color="gray">
                  new sales will show as originating from the new Shop;
                </Text>
              </li>
              <li>
                <Text body color="gray">
                  move the “eCom” Register to the new Shop.
                </Text>
              </li>
            </ul>
          </div>
          <form onSubmit={handleSubmit}>
            <FormField
              label="Synchronize from Retail Shop"
              status={
                errors.shop || errors.shop
                  ? {
                      type: 'error',
                      message: errors.shop || errors.shop,
                    }
                  : null
              }
            >
              <Select
                disabled={!shops.length || isSubmitting}
                value={values.shopId}
                onChange={event => {
                  const { value } = event.target;
                  setFieldValue('shopId', value);
                }}
              >
                {shops.map(shop => (
                  <option key={shop.id} value={shop.id}>
                    {truncate(shop.name, { length: 75 })}
                  </option>
                ))}
              </Select>
            </FormField>
          </form>
        </ModalBody>
        <ModalFooter>
          <Group className="cr-justify-end">
            <Button onClick={() => onClose()}>Cancel</Button>
            <Button
              variant="secondary"
              fill
              loading={isSubmitting}
              onClick={handleSubmit}
              disabled={!shops.length || values.shopId === shopId}
            >
              I understand. Change Synchronize from Retail Shop
            </Button>
          </Group>
        </ModalFooter>
      </Modal>
    );
  }
}

const enhancedShopModal = withFormik({
  mapPropsToValues: props => ({
    shopId: get(props, 'shopId', ''),
  }),
  validationSchema: ({ shops }) =>
    Yup.object().shape({
      shopId: Yup.number().oneOf(shops.map(shop => shop.id)),
    }),
  handleSubmit: async (values, formikBag) => {
    formikBag.setSubmitting(true);

    const { accountId } = formikBag.props;
    const { shopId } = values;

    try {
      await axios.put(`/staff/accounts/${accountId}/ecom/shop`, {
        data: {
          ecom: {
            shop_id: shopId,
          },
        },
      });
      formikBag.props.onConfirm({ updateData: true, message: 'Sync Retail Shop pushed to queue' });
    } catch (e) {
      window.alertUser(get(e, 'response.data.errors[0].detail') || 'An error occurred');
    }

    formikBag.setSubmitting(false);
    formikBag.props.onClose();
  },
})(ShopModal);

const mapStateToProps = state => ({
  shops: getValues(entities.staffShop)(state),
  isLoading: !!getProcessing({
    entity: entities.staffShop,
    list: true,
    actionType: actionTypes.LOADING,
  })(state),
  loadingErrors: getErrors({
    entity: entities.staffShop,
    list: true,
    actionType: actionTypes.LOADING,
  })(state),
});

const mapDispatchToProps = dispatch => ({
  getShopsData: (url, options, onSuccess) =>
    dispatch(getData({ url, entity: entities.staffShop, list: true, options, onSuccess })),
});

const ConnectedShopModal = connect(mapStateToProps, mapDispatchToProps)(enhancedShopModal);

export default ConnectedShopModal;
